import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Moksh Gupta </span>
            from <span className="purple"> Jhansi, India.</span>
            <br />
             I am currently employed as an Associate Software Engineer at Linktoany.
            <br />
            I am currently pursuing my B.Tech in my final year at Jaypee University of Engineering and Technology (JUET), Guna.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Moksh</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
